// ProbaWorkflows's Routes
import ComingSoon from "@/components/coming_soon/ComingSoon.vue";
import EntityAttributeForms from "@/components/probaworkflows_base_components/AttributeForms/EntityAttributeForms.vue";
import DashboardComponent from "@/components/probaworkflows_base_components/DashboardComponent/DashboardComponent.vue";
import EntityOnboardingForms from "@/components/probaworkflows_base_components/OnboardingForms/EntityForm/EntityForm.vue";
import ProbaWorkflowsLayout from "@/layouts/probaworkflows_base_layout/ProbaWorkflowsLayout.vue";
import ActionManagement from "@/views/global/management/action_management/ActionManagement.vue";
import AssigningPermissions from '@/views/global/management/assigning_permissions/AssigningPermissions.vue';
import CreatingAPolicy from '@/views/global/management/creating_a_policy/CreatingAPolicy.vue';
import PermissionManagement from "@/views/global/management/permission_management/PermissionManagement.vue";
import RolesManagement from "@/views/global/management/roles_management/RolesManagement.vue";
import UserManagement from "@/views/global/management/user_management/UserManagement.vue";
import ConditionManagement from "@/views/probaworkflows_base/compliance/configurations/ongoing_compliance/conditions/ConditionManagement.vue";
import SignUp from "@/views/probaworkflows_base/entity/entity_onboarding/sign_up/SignUp.vue";
import CompanyManagement from "@/views/probaworkflows_base/management/company_management/CompanyManagement.vue";
import ConfigureCompanyManagement from "@/views/probaworkflows_base/management/configure_company_management/ConfigureCompanyManagement.vue";
import CreateEntity from "@/views/probaworkflows_base/management/entity_management/create_entity/CreateEntity.vue";
import ManageEntityType from "@/views/probaworkflows_base/management/entity_management/manage_entity_type/ManageEntityType.vue";
import ViewEntityType from "@/views/probaworkflows_base/management/entity_management/view_entity_type/ViewEntityType.vue";
import FormManagement from "@/views/probaworkflows_base/management/form_management/FormManagement.vue";
import GenerateReports from "@/views/probaworkflows_base/management/report_management/generate_reports/GenerateReports.vue";
import GeneratedReports from "@/views/probaworkflows_base/management/report_management/generated_reports/GeneratedReports.vue";
import ReportTemplates from "@/views/probaworkflows_base/management/report_management/report_templates/ReportTemplates.vue";
import ConfigureTemplate from "@/views/probaworkflows_base/management/template_managment/configure_template/ConfigureTemplate.vue";
import DataPoints from "@/views/probaworkflows_base/management/template_managment/data_points/DataPoints.vue";
import UploadTemplate from "@/views/probaworkflows_base/management/template_managment/upload_template/UploadTemplate.vue";
import ViewTemplate from "@/views/probaworkflows_base/management/template_managment/view_templates/ViewTemplate.vue";
import OverView from "@/views/probaworkflows_base/overview/OverView.vue";
import FacialBiometric from "@/views/probaworkflows_base/verification/facial_biometric/FacialBiometric.vue";
import trustfirstadditional from "./probaworkflowsadditional";



const probaworkflows_routes = [{
    path: "/",
    name: "ProbaWorkflowsBase",
    component: ProbaWorkflowsLayout,

    children: [

      {
        path: "/overview",
        name: "overview",
        component: OverView,
        meta: {
          breadcrumb: "Overview",
          branch: 'overview'
        }
      },
      {
        path: "/coming_soon",
        name: "coming_soon",
        component: ComingSoon,
      },
      {
        path: "/dashboard/:dashboard_id",
        name: "DashboardWithId",
        component: DashboardComponent,
      },
      {
        path: "/user_management",
        name: "UserManagement",
        component: UserManagement,
        meta: {
          breadcrumb: "User Management",
          branch: 'configure',
          isTab: true
        }
      },
      {
        path: "/roles_management",
        name: "RolesManagement",
        component: RolesManagement,
        meta: {
          breadcrumb: "Role Management",
          branch: 'configure',
          isTab: true
         }
      },
      {
        path: "/permission_management",
        name: "PermissionManagement",
        component: PermissionManagement,
      },
      {
        path: '/assigning_permissions',
        name: 'assigning_permissions',
        component: AssigningPermissions,
        meta: {
          breadcrumb: "Policy Permission Management",
          branch: 'configure',
          isDynamic: true
        }
      },
      {
        path: '/creating_a_policy',
        name: 'creating_a_policy',
        component: CreatingAPolicy,
        meta: {
          breadcrumb: "Policy Management",
          branch: 'configure',
          isTab: true
         }
      },
      {
        path: "/action_management",
        name: "action_management",
        component: ActionManagement,
        meta: {
          breadcrumb: "Action Management",
          branch: 'configure',
          isTab: true
         }
      },
      // Entity Management
      {
        path: "/manage_entity_type",
        name: "manage_entity_type",
        component: ManageEntityType,
        meta: {
          breadcrumb: "Case Type",
          branch: 'configure',
          isTab: true
         }
      },
      {
        path: "/data_points",
        name: "data_points",
        component: DataPoints,
      },

      {
        path: "/view_entity_type",
        name: "view_entity_type",
        component: ViewEntityType,
        meta: { breadcrumb: "Case Type Configuration",
          branch: 'configure',
          isDynamic: true
         }
      },
      {
        path: "/create_entity",
        name: "create_entity",
        component: CreateEntity,
        meta: {
          breadcrumb: "Form Configuration",
          branch: 'configure',
          isDynamic: true
        }
      },
      //compliance
      {
        path: '/condition_management',
        name: 'ConditionManagement',
        component: ConditionManagement,
        meta: {
          breadcrumb: "Set Up Conditions For A Rule",
          branch: 'configure',
          isTab: true
         }
      },

      // template management
      {
        path: "/view_template",
        name: "view_template",
        component: ViewTemplate,
        meta: {
          breadcrumb: "Template Management",
          branch: 'configure',
          isTab: true
        }
      },
      {
        path: "/upload_template",
        name: "upload_template",
        component: UploadTemplate,
        meta: {
          breadcrumb: "Upload Template",
          branch: 'configure',
          isDynamic: true
        }
      },
      {
        path: "/configure_template/",
        name: "configure_template",
        component: ConfigureTemplate,
        meta: {
          breadcrumb: "Template Configuration",
          branch: 'configure',
          isDynamic: true
        }

      },
      {
        path: "/form_management/",
        name: "form_management",
        component: FormManagement,
        meta: {
          breadcrumb: "Form Management",
          branch: 'configure',
          isTab: true
         }
      },
      {
        path: "/generate_reports/",
        name: "generate_reports",
        component: GenerateReports,
        meta: {
          breadcrumb: "Report Management",
          branch: "configure",
          isTab: true,
        }
      },
      {
        path: "/report_templates/",
        name: "report_templates",
        component: ReportTemplates,
        meta: {
          breadcrumb: "Report Templates",
          branch: "configure",
          isTab: true,
        }
      },
      {
        path: "/generated_reports/",
        name: "generated_reports",
        component: GeneratedReports,
        meta: {
          breadcrumb: "Generated Reports",
          branch: "configure",
          isTab: true,
        }
      },
      {
        path: "/company_management",
        name: "company_management",
        component: CompanyManagement,
      },
      {
        path: "/configure_company_management",
        name: "configure_company_management",
        component: ConfigureCompanyManagement,
        meta: {
          breadcrumb: "Configure Company Management",
          branch: 'configure'
        }
      },

      //compliance
      {
        path: '/compliance/condition-management',
        name: 'ConditionManagement',
        component: ConditionManagement,
      },

      ...trustfirstadditional

    ]
  },
  {
    path: "/facial_biometric/",
    name: "facial_biometric",
    component: FacialBiometric,
  },

  {
    path: "/referral_sign_up/:project_id?",
    name: "referral_sign_up",
    component: SignUp,
    meta: { requires_auth: false, requires_otp: false }, // No authentication required for login
  },
  {
    path: "/entity_onboarding_forms",
    name: "entity_onboarding_forms",
    component: EntityOnboardingForms,
  },
  {
    path: "/attribute_forms",
    name: "attribute_forms",
    component: EntityAttributeForms,
  },


]


export default probaworkflows_routes;
